(function() {
  const toggleButton = document.querySelector('[data-js-key-benefits-toggle]');
  const hiddenList = document.querySelector('[data-js-key-benefits-hidden]');
  
  if (toggleButton && hiddenList) {
    toggleButton.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        hiddenList.style.display = 'none';
        hiddenList.classList.remove('is-expanded');
        this.setAttribute('aria-expanded', 'false');
        this.textContent = 'Read more';
      } else {
        hiddenList.style.display = 'flex';
        hiddenList.classList.add('is-expanded');
        this.setAttribute('aria-expanded', 'true');
        this.textContent = 'Read less';
      }
    });
  }
})();

